function CreateEmailTemplate() {
  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <div>
          <h5>Create Email Template</h5>
        </div>
      </div>
      <div className="card border rounded-border-sm  mt-4">
        <div className="p-2 border-bottom">
          <p className="f-500">Email Details</p>
        </div>
        <div className="p-2 my-3 flex-wrap justify-content-between">
          <div className="fc-12">
            <div className="fc-5">
              <div className="input-wrapper">
                <p className="input-title">Template Name</p>
                <label className="input">
                  <input type="text" placeholder="Template Name" />
                </label>
              </div>
            </div>
          </div>
          <div className="fc-5">
            <div className="input-wrapper">
              <p className="input-title">Sender ID</p>
              <label className="input">
                <input type="text" placeholder="Sender ID" />
              </label>
            </div>
          </div>
          <div className="fc-5">
            <div className="input-wrapper">
              <p className="input-title">Sender Name</p>
              <label className="input">
                <input type="text" placeholder="Sender Name" />
              </label>
            </div>
          </div>
          <div className="fc-12">
            <div className="input-wrapper">
              <p className="input-title">Mail Subject</p>
              <label className="input">
                <input type="text" placeholder="Mail Subject" />
              </label>
            </div>
          </div>
          <div className="fc-12">
            <div className="input-wrapper">
              <p className="input-title ">Email Content</p>
              <div className="card p-2 my-2 bg-light">
                <p className="mini-text">
                  For Dynamic values use keyword <b>param</b> followed by
                  position inside {`"@{}"`}. e.g. <b>{"@{param1}"}</b>
                </p>
              </div>
              <textarea
                className="textarea"
                rows={14}
                placeholder="Message Body"
              ></textarea>
            </div>
          </div>
          <div className="fc-12 text-right">
            <button className="btn-primary btn--sm">Save</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateEmailTemplate;
